import {SetGetByIdLottery} from './thunk/setGetByIdLottery';
import {SetGetListLottery} from './thunk/setGetListLottery';
import {SetGetPrizeLottery} from './thunk/setGetPrizeLottery';
import {SetGetStatLottery} from './thunk/setGetStatLottery';
import {SetGetWinnersLottery} from './thunk/setGetWinnersLottery';
import {SetPostCheckLottery} from './thunk/setPostCheckLottery';
import {SetPostCreateLottery} from './thunk/setPostCreateLottery';
import {SetPostIssueLottery} from './thunk/setPostIssueLottery';
import {SetPostUpdateLottery} from './thunk/setPostUpdateLottery';

export const Thunks = {
    SetGetByIdLottery,
    SetGetListLottery,
    SetGetPrizeLottery,
    SetGetStatLottery,
    SetGetWinnersLottery,
    SetPostCheckLottery,
    SetPostCreateLottery,
    SetPostIssueLottery,
    SetPostUpdateLottery
}